import { useMutation, useQueryClient } from '@tanstack/react-query'
import { connect } from 'getstream'
import { streamApi, supabase } from '../../api'

const doFollow = async (
  id: number | string,
) => {
  const { data: userData } = await supabase.auth.getSession()
  const userId = userData?.session?.user.id
  const REACT_APP_STREAM_API_KEY: string = process.env.REACT_APP_STREAM_API_KEY || ''
  const REACT_APP_STREAM_APP_ID: string = process.env.REACT_APP_STREAM_APP_ID || ''

  const result = await streamApi.post(
    '/getToken',
    { id: userId || 'anonymous' },
  )
  const client = connect(
    REACT_APP_STREAM_API_KEY,
    result.token,
    REACT_APP_STREAM_APP_ID,
  )

  const userNotificationsFeed = await client.feed(
    'notification',
    userId,
  );

  const { data: postData, error } = await supabase
    .from('following_users_assets')
    .insert({
      user_id: userData?.session?.user?.id,
      asset_id: id,
    })
    .select()
    .single();

  userNotificationsFeed.follow('asset', `${id}`, { limit: 0 })

  if (error) {
    throw new Error(error.message)
  }

  return postData
}

const doUnFollow = async (
  id: number | string,
) => {
  const { data: userData } = await supabase.auth.getSession()
  const userId = userData?.session?.user.id
  const REACT_APP_STREAM_API_KEY: string = process.env.REACT_APP_STREAM_API_KEY || ''
  const REACT_APP_STREAM_APP_ID: string = process.env.REACT_APP_STREAM_APP_ID || ''

  const result = await streamApi.post(
    '/getToken',
    { id: userId || 'anonymous' },
  )
  const client = connect(
    REACT_APP_STREAM_API_KEY,
    result.token,
    REACT_APP_STREAM_APP_ID,
  )

  const userNotificationsFeed = await client.feed(
    'notification',
    userId,
  );

  const { error } = await supabase
    .from('following_users_assets')
    .delete()
    .eq('user_id', userData?.session?.user?.id)
    .eq('asset_id', id);

  userNotificationsFeed.unfollow('asset', `${id}`)
  if (error) {
    throw new Error(error.message)
  }

  return null
}

export default function useFollowAsset(
  id: number | string,
) {
  const queryClient = useQueryClient();
  return useMutation((follow: boolean) => (follow ? doFollow(id) : doUnFollow(id)), {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries(['assetFollowers']);
      return res
    },
  })
}
